<template>
    <b-card class="card-shadow">
        <CourseRolesModal
            v-model="showRolesModal"
            :course-id="course.id"
            :course-name="course.name"
            :course-roles="course.roles"
        />

        <template #header>
            <div class="d-flex align-items-center">
                <h6 class="my-0" v-b-tooltip.hover.top :title="tooltip">
                    <router-link :to="{ name: 'Course', params: { courseId: course.id } }" :class="routerLinkClass">
                        {{ title }}
                    </router-link>
                </h6>
                <div class="flex-grow-1"></div>
                <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="openRolesModal"
                    v-b-tooltip.hover.left="assignedRoles"
                >
                    <b-icon icon="shield-check"></b-icon>
                </b-button>
            </div>
        </template>

        <b-overlay :show="!courseDetails" class="themes-list overlay">
            <div v-if="courseDetails">

                <div v-for="theme in courseDetails.themes" :key="theme.id" class="theme-item">
                    <span class="d-flex align-items-center">

                        {{ theme.name }}

                        <div class="flex-grow-1"></div>

                        <div class="icon-with-badge" title="Materiales" v-b-tooltip.hover.left>
                            <b-icon icon="file-earmark-pdf"></b-icon>
                            <span class="badge">{{ numMaterials(theme) }}</span>
                        </div>

                        <div class="icon-with-badge ms-3" title="Evaluaciones" v-b-tooltip.hover.left>
                            <b-icon icon="patch-check"></b-icon>
                            <span class="badge">{{ numEvaluations(theme) }}</span>
                        </div>

                    </span>
                </div>

                <div v-if="themesEmpty" class="text-center my-1 text-danger align-center">
                    <small>
                        <b-icon icon="exclamation-triangle" class="me-2" />
                        Sin temas
                    </small>
                </div>

            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js';
import CourseRolesModal from './Course-roles-modal.vue';

export default {
    name: 'CourseCard',

    components: {
        CourseRolesModal
    },

    props: {
        course: Object
    },

    data() {
        return {
            status: 'completado',
            courseDetails: null,
            showRolesModal: false
        }
    },

    computed: {
        title() {
            return this.course?.name;
        },

        numCurriculum() {
            return this.courseDetails?.themes?.length;
        },

        themesEmpty() {
            return this.courseDetails?.themes?.length === 0;
        },

        routerLinkClass() {
            return this.themesEmpty ? 'disabled-link' : '';
        },

        tooltip() {
            return this.themesEmpty ? 'Curso vacío' : '';
        },

        assignedRoles() {
            return 'Asignado a: ' + this.course.roles.map(role => role.name)
                .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
                .join(', ');
        },
    },

    async mounted() {
        await this.getCourse();

        this.$eventBus.$on(EventNames.UpdateCurrentCurriculum, async ({ courseId }) => {
            if (courseId === this.course.id) {
                await this.getCourse();
            }
        });

        this.$eventBus.$on(EventNames.UpdateCurriculumList, async (courseId) => {
            if (courseId === this.course.id) {
                await this.getCourse();
            }
        });
    },

    methods: {
        ...mapActions(["getCourseById"]),

        async getCourse() {
            let result = await this.getCourseById({ courseId: this.course.id });
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.error.message);
            }
            this.courseDetails = result.data;
        },

        numMaterials(theme) {
            return theme.materials.length;
        },

        numEvaluations(theme) {
            return theme.evaluations.length;
        },

        openRolesModal() {
            this.showRolesModal = true;
        }
    }
}
</script>

<style scoped>
.card-shadow {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.1s;
}

.card-shadow:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
}

.card-group-deck {
    height: 150px;
}

.themes-list {
    max-height: 200px;
    overflow-y: auto;
    padding: 0.5rem;
}

.theme-item {
    font-size: 0.9rem;
    padding: 0.3rem 0;
    border-bottom: 1px solid #eee;
}

.theme-item:last-child {
    border-bottom: none;
}

.icon-with-badge {
    display: inline-block;
    position: relative;
}

.badge {
    position: absolute;
    top: -2px;
    right: -8px;
    background-color: #e2d9f8;
    color: rgb(0, 0, 0);
    border-radius: 25%;
    padding: 1px;
    font-size: 0.6rem;
    min-width: 15px;
    text-align: center;
}

.overlay {
    min-height: 80px;
}

.disabled-link {
    opacity: 0.8;
}
</style>